import React from 'react';

export default function HeaderColumn({ children, style = {} }) {
    return (
        <div className="p-3 bg-primary text-white h4" style={style}>
            {children}
        </div>
    );
}
